// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ConfirmDeleteButton from '../../../../shared/components/file-attachment-panel/confirm-delete-button';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import {downloadFile} from '../../../../shared/services/file-download';

function onFileClick(file) {

    downloadFile(file);

}

const FileAttachmentSingle = props =>
    <section className='file-attachments'>
        <ul>
            {props.file.objectKey &&
            <li>
                <button
                    className='button-text  button-link'
                    onClick={onFileClick.bind(null, props.file)}
                >
                    {props.file.fileName}
                </button>
                {props.showDeleteIcon ?
                    <ConfirmDeleteButton
                        file={props.file}
                        onDelete={props.onFileDelete}
                    /> : null
                }
            </li>
            }
        </ul>
    </section>;

FileAttachmentSingle.displayName = 'FileAttachmentSingle';

FileAttachmentSingle.propTypes = {
    file: PropTypes.instanceOf(File).isRequired,
    onFileDelete: PropTypes.func.isRequired,
    showDeleteIcon: PropTypes.bool
};
FileAttachmentSingle.defaultProps = {
    showDeleteIcon: true
};
export default FileAttachmentSingle;



// WEBPACK FOOTER //
// ./src/claim/shared/components/file-attachment-single-panel/file-attachment-single.js